import React, { useEffect, useState } from 'react'
import { DinamicFamilia } from './dinamicFamilia/DinamicFamilia'
import { Grid, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import TextAreaField from '../../formFields/TextAreaField';
import InputField from '../../formFields/InputField';
import { useFormikContext } from 'formik';
import InputNumeric from '../../formFields/InputNumeric';

export const Familia = (props:any) => {


  const dispatch = useDispatch();

  const formikProps:any = useFormikContext();

  const [beneficiarios, setBeneficiarios] = useState(0);

  // const { sizefamily }:any = useSelector( (state:any) => state.sizefamily );


  const numBeneficiary = (event:any) => {
   
    const valueInput = event.target.value;

    if ( valueInput.toLowerCase() == 'e' ) return false;


    setBeneficiarios(valueInput);
    formikProps.setFieldValue('numOfBeneficiary', valueInput);
    
   
  }

 console.log('hjhjhjhjhjhjhjhjhjhj ',props)
  const { formField: {
    // DATOS CLIENTE 
    numOfBeneficiary

    }
  } = props;

  


  return (

    <>
        <Grid item xs={3}>
          <InputNumeric 
            name={numOfBeneficiary.name}
            label={numOfBeneficiary.label}
            variant="outlined"
            onChange={ (val:any) => numBeneficiary(val) }
            
          />
        </Grid>
        
         <DinamicFamilia children={beneficiarios} />
    </>
  )

}
